import DefaultDetail from "@Common/DefaultDetail";
import { inject, observer } from "mobx-react";

import "./style.scss";
import { getEditInputsByStep } from "../../config.jsx";

const Step3 = inject("mainStore")(
    observer(({ mainStore, setStep, step, countOfSteps }) => {
        const detailData = mainStore.getMainStore("detailData");
        const inputsNew = getEditInputsByStep({ mainStore, detailData }).step3 || [];

        return <DefaultDetail apiUrl={"/promo/offers"} inputs={inputsNew} page={"offers"} setStep={setStep} step={step} countOfSteps={countOfSteps} />;
    }),
);

export default Step3;
